export default "__VITE_ASSET__a2eb9206__"